export const newsLandingGraphQuery =
  `{
    news-landing {
      ...news-landingFields
      content {
        ...on headline_title_text {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on news_promote {
          non-repeat {
            news_1 {
              ...on news {
                ...newsFields
              }
            }
            news_2 {
              ...on news {
                ...newsFields
              }
            }
            news_3 {
              ...on news {
                ...newsFields
              }
            }
          }
        }
        ...on category_block {
          repeat {
            ...repeatFields
            category_field {
              ...on news-category {
                ...news-categoryFields
                content {
                  ...on category_block {
                    non-repeat {
                      block_title
                    }
                    repeat {
                      ...repeatFields
                      page_brand {
                        ...on brand {
                          ...brandFields
                        }
                      }
                      news_a {
                        ...on news {
                          ...newsFields
                        }
                      }
                      news_c {
                        ...on news {
                          ...newsFields
                        }
                      }
                      news_b {
                        ...on news {
                          ...newsFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`

export const sliderTabsBarGraphQuery =
  `{
    brand {
      ...brandFields
      content {
        ...on slider_tabs_bar {
          repeat {
            ...repeatFields
            details_link {
              ...on la-maison-category {
                ...la-maison-categoryFields
                content {
                  ...on categorie {
                    repeat {
                      ...repeatFields
                      block_brand_page {
                        ... on brand {
                          ...brandFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        ...on hero_static_banner {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on title_image {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on title_text_image {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on cta {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on fullscreen_image_banner {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on basic_page_title {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on video_gif {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on quote {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on headline_title_text {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on title_text {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on title_text_center {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on edito_text_image {
          non-repeat {
            ...non-repeatFields
          }
        }
        ...on slider_tabs_bar {
          repeat {
            ...repeatFields
            details_link {
              ...on la-maison-category {
                ...la-maison-categoryFields
                content {
                  ...on categorie {
                    non-repeat {
                      ...non-repeatFields
                    }
                    repeat {
                      ...repeatFields
                      block_brand_page {
                        ... on brand {
                          ...brandFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`
